query CollectionTypesList(
  $page: Int
  $rowsPerPage: Int
  $filter: CollectionTypesFilterInput
) {
  collectionTypes(page: $page, rowsPerPage: $rowsPerPage, filter: $filter) {
    count
    nodes {
      id
      title
      platformId
      showInSearch
      collectionDisplayMode
      createdAt
      updatedAt
      deletedAt
      deleted
    }
  }
}
